import { getDataAPI, postDataAPI } from "../../../helper/NonAuthApi";

export const userLogin = (payload) => {
  return postDataAPI("/api/Auth/Login", { ...payload });
};
export const userMainLogin = (payload) => {
  return postDataAPI("/api/Auth/verification-code/verify", { ...payload });
};
export const userResendOtp = (payload) => {
  return postDataAPI("/api/Auth/verification-code/create", { ...payload });
};
export const resetPassword = (payload) => {
  return getDataAPI("/api/Auth/ResetPassword", { ...payload });
};

export const confirmEmail = (payload) => {
  return postDataAPI("/api/Auth/ConfirmEmail", { ...payload });
};

export const verificationCode = (payload) => {
  return postDataAPI("/api/Auth/VerificationCode", { ...payload });
};

export const userPassword = (payload) => {
  return postDataAPI("/api/Auth/ResetPassword", { ...payload });
};
